<template>
  <el-table
    :data="tableData"
    class="egl-table"
    stripe
    :span-method="spanMethod"
    :cell-class-name="setCellClassName"
  >
    <el-table-column :label="$locale('global.cinemaName')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.cinemaId" @change="selectCinemaId(scope.$index)">
          <el-option :value="item.id" :label="item.name" v-for="item in cinemaList" :key="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.itemName')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.otherRevenueId" @change="selectOtherRevenueId(scope.$index)">
          <el-option :value="item.id" :label="item.name" v-for="item in otherRevenueOption[scope.$index]" :key="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.unitPrice')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.price"
          @input="setRowTotalPrice(scope.$index, 'price', true)"
          @blur="setRowTotalPrice(scope.$index, 'price', false)"
          v-if="scope.$index < tableData.length - 1"
        ></el-input>
        <span v-else>{{ scope.row.price }}</span>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.quantity')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.inventory"
          @input="setRowTotalPrice(scope.$index, 'inventory', true)"
          @blur="setRowTotalPrice(scope.$index, 'inventory', false)"
          v-if="scope.$index < tableData.length - 1"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.unit')">
      <template slot-scope="scope">
        <el-input v-model="scope.row.unit" @blur="setProp" v-if="scope.$index < tableData.length - 1"></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.offsetAmount')">
      <template slot-scope="scope">
        {{ scope.row.payAmount.toLocaleString() }}
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.detail') + '/' + $locale('global.description')">
      <template slot-scope="scope">
        <el-input v-model="scope.row.comment" v-if="scope.$index < tableData.length - 1" :placeholder="$locale('accountPayable.placeholder.input')" @blur="setProp"></el-input>
      </template>
    </el-table-column>

    <el-table-column width="120">
      <template slot-scope="scope">
        <div v-if="scope.$index < tableData.length - 1">
          <el-button class="handle-btn egl-btn-white-gray-border" v-if="tableData.length > 2" @click="removeRow(scope.$index)">
            <i class="el-icon-minus"></i>
          </el-button>
          <el-button class="handle-btn egl-btn-white-gray-border" v-if="scope.$index == tableData.length - 2" @click="addRow">
            <i class="el-icon-plus"></i>
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { createOffsetRevenueTableTr } from "@/assets/js/accountPayable.js";
import { getOtherRevenueList } from "@/helpers/service/api/accountPayable.js";
import { mapState } from "vuex";

export default {
  name: "AccountPayablePaymentOtherOffsetTable2",
  data() {
    return {
      tableData: [],
      otherRevenueList: [],
      otherRevenueOption: [],
    };
  },
  computed: {
    ...mapState("api", { cinemaList: state => state.cinemaList }),
    ...mapState("accountPayable", { offsetHistory: state => state.offsetHistory }),
  },
  methods: {
    setProp() {
      let lastTr_payAmount = 0;

      let tableData = [ ...this.tableData ];
      let targetTable = [];

      for (let i = 0; i < tableData.length - 1; i++) {
        if (tableData[i].otherRevenueId) {
          lastTr_payAmount += tableData[i].payAmount;
          targetTable.push({ ...tableData[i] });
        }
      }

      this.tableData[this.tableData.length - 1].payAmount = lastTr_payAmount;
      this.$emit("setOffset", "revenue", targetTable, lastTr_payAmount);
    },
    selectCinemaId(index) {
      const cinemaId = this.tableData[index].cinemaId;
      let cinemaName = "";
      let isGetOtherRevenue = false;

      for (let i = 0; i < this.cinemaList.length; i++) {
        if (cinemaId == this.cinemaList[i].id) {
          cinemaName = this.cinemaList[i].name;
          break;
        }
      }

      for (let i = 0; i < this.otherRevenueList.length; i++) {
        if (cinemaId == this.otherRevenueList[i].cinemaId) {
          isGetOtherRevenue = true;
          this.otherRevenueOption[index] = [ ...this.otherRevenueList[i].list ];
          break;
        }
      }

      this.tableData[index].cinemaName = cinemaName;
      this.tableData[index].otherRevenueId = "";
      this.tableData[index].otherName = "";
      this.tableData[index].price = "-";
      this.tableData[index].inventory = "-";
      this.tableData[index].unit = "-";
      this.tableData[index].payAmount = 0;
      this.tableData[index].comment = "";
      this.setProp();

      if (!isGetOtherRevenue) {
        this.getOtherRevenueList_fn(cinemaId, index);
      }
    },
    getOtherRevenueList_fn(id, index) {
      getOtherRevenueList(id).then(res => {
        if (res.success) {
          let otherRevenueOption = [ ...this.otherRevenueOption ];
          let otherRevenueList = [ ...this.otherRevenueList ];

          otherRevenueList.push({
            cinemaId: id,
            list: res.data.data,
          });
          otherRevenueOption[index] = res.data.data;

          this.otherRevenueList = otherRevenueList;
          this.otherRevenueOption = otherRevenueOption;
        }
      }).catch(err => {});
    },
    selectOtherRevenueId(index) {
      const id = this.tableData[index].otherRevenueId;
      let otherRevenueObj = {};

      for (let i = 0; i < this.otherRevenueOption[index].length; i++) {
        if (id == this.otherRevenueOption[index][i].id) {
          otherRevenueObj = { ...this.otherRevenueOption[index][i] };
          break;
        }
      }

      this.tableData[index].otherName = otherRevenueObj.name;
      this.tableData[index].price = otherRevenueObj.price;
      this.tableData[index].inventory = otherRevenueObj.inventory;
      this.tableData[index].unit = otherRevenueObj.unit;
      this.tableData[index].payAmount = otherRevenueObj.price * otherRevenueObj.inventory;
      this.tableData[index].comment = otherRevenueObj.comment;
      this.setProp();
    },
    setRowTotalPrice(index, keyName, isInput = true) {
      let price = this.tableData[index].price;
      let inventory = this.tableData[index].inventory;
      let payAmount = 0;
      let num = this.tableData[index][keyName];

      price = parseInt(price.toString().replace(/[^\d-]/g, "")) || 0;
      inventory = parseInt(inventory.toString().replace(/[^\d-]/g, "")) || 0;
      payAmount = price * inventory;

      num = num.toString().replace(/[^\d-]/g, "");
      if (!isInput) {
        num = parseInt(num) || 0;
      }

      this.tableData[index].price = price;
      this.tableData[index].inventory = inventory;
      this.tableData[index].payAmount = payAmount;
      this.tableData[index][keyName] = num;
      this.setProp();
    },
    spanMethod({rowIndex, columnIndex}) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };
      let dataLength = this.tableData.length;

      if (rowIndex == dataLength - 1) {
        if (columnIndex == 2) {
          obj.colspan = 3;
        } else if (columnIndex >= 3) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj
    },
    setCellClassName({rowIndex, columnIndex}) {
      if (columnIndex == 2 || columnIndex == 3 || columnIndex == 4 || columnIndex == 5 || rowIndex == this.tableData.length - 1) {
        return "ta-r"
      }
    },
    addRow() {
      let rowItem = createOffsetRevenueTableTr();
      let tableData = [ ...this.tableData ];

      tableData.splice(tableData.length - 1, 0, rowItem);
      this.tableData = tableData;
      this.otherRevenueOption = [ ...this.otherRevenueOption, [] ];
    },
    removeRow(index) {
      let tableData = [ ...this.tableData ];
      let otherRevenueOption = [ ...this.otherRevenueOption ];

      tableData.splice(index, 1);
      otherRevenueOption.splice(index, 1);

      this.tableData = tableData;
      this.otherRevenueOption = otherRevenueOption;
      this.setProp();
    },
  },
  mounted() {
    let lastTr = {
      price: this.$locale("global.total"),
      payAmount: 0,
    };
    let trs = [];

    if (this.offsetHistory.revenue && this.offsetHistory.revenue.length > 0) {
      this.offsetHistory.revenue.map((item, index) => {
        trs.push({ ...item });

        lastTr.payAmount += item.payAmount;

        this.getOtherRevenueList_fn(item.cinemaId, index);
      });

      this.$emit("setOffset", "revenue", trs, lastTr.payAmount);
    } else {
      trs.push(createOffsetRevenueTableTr());
    }

    this.tableData = [ ...trs, lastTr ];
    this.otherRevenueOption = [ [] ];
  },
};
</script>
